import "./index.css";

import { FlagProvider } from "@unleash/proxy-client-react";
import React from "react";
import { AuthProvider } from "react-auth-kit";
import ReactDOM from "react-dom/client";
import TagManager from "react-gtm-module";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const config = {
  url: `${process.env.REACT_APP_BASE_URL}/feature_flags/proxy`,
  clientKey: "not-used", // Not used
  refreshInterval: 60, // How often (in seconds) the client should poll the proxy for updates
  appName: `${process.env.REACT_APP_GITLAB_ENVIRONMENT}`, // The name of the application's environment. Note that this refers to the backend environment in GitLab, not the frontend. The frontend environment should be kept in sync with the backend environment.
};

const context = {}

const tagManagerArgs = {
  gtmId: process.env.REACT_APP_GTM_ID
}

TagManager.initialize(tagManagerArgs)

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AuthProvider authType={"cookie"}
      authName={"_auth"}
      cookieDomain={window.location.hostname}
      cookieSecure={window.location.protocol === "https:"}>
      <BrowserRouter>
        <FlagProvider config={config} context={context}>
          <App />
        </FlagProvider>
      </BrowserRouter>
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
